/**
 * 该文件由脚本生成, 不要直接修改该文件，请修改 scripts/track-events-generator/helpers/generates/trackCommonParamsZod.ts 文件
 * docUrl: https://docs.google.com/spreadsheets/d/1FI8liihDdj2luj0DAXzEXXfJuJyPKbMbe61QYCnhiO8/edit?gid=1818942798#gid=1818942798
 */

import { z } from 'zod'

export type LiteralStringUnion<T extends string, U = string> =
  | T
  | (U & { _?: never })

export const commonParamsSchema = z.object({
  project: z.string().optional(),
  commUserId: z.string(),
  commEmail: z.string(),
  /**
   * - anon: 匿名用户
   * - free: 免费用户
   * - 格式：pro_$29_mo, 购买pro月套餐且价格为$29用户
, mo 或者 yr
   * - expired: 曾经购买过套餐，现在是免费用户状态
   */
  commUserStatus: z.union([
    z.literal(`anon`),
    z.literal(`free`),
    z.literal(`expired`),
    z.string(),
  ]) as z.ZodType<LiteralStringUnion<'anon' | 'free' | 'expired'>>,
  commUserGroup: z.string(),
  /**
   * - 用户的浏览器
   */
  commBrowser: z.string().optional(),
  commDeviceId: z.string().optional(),
  /**
   * - Mobile: 移动
   * - Desktop: 桌面端
   * - Tablet: 平板
   */
  commDeviceType: z.enum([`Mobile`, `Desktop`, `Tablet`]).optional(),
  /**
   * - 操作系统
   */
  commOs: z.string().optional(),
  /**
   * - 当前用户所在国家
   */
  commCountry: z.string().optional(),
  /**
   * - 用户浏览的语言
   */
  commLanguage: z.string(),
  /**
   * - 当前事件发生的url
   */
  commCurrentUrl: z.string(),
  commPathName: z.string(),
  commHost: z.string(),
  commTimestamp: z.number(),
})

export type CommonParamsSchemaInput = z.input<typeof commonParamsSchema>
export type CommonParamsSchemaOutput = z.output<typeof commonParamsSchema>

/**
 * 该文件由脚本生成, 不要直接修改该文件，请修改 scripts/track-events-generator/helpers/generates/trackCommonParamsZod.ts 文件
 * docUrl: https://docs.google.com/spreadsheets/d/1FI8liihDdj2luj0DAXzEXXfJuJyPKbMbe61QYCnhiO8/edit?gid=1818942798#gid=1818942798
 */
